/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import {
  DONE_FETCHING_SCHOOL_WIDGET_DATA,
  DONE_FETCHING_SCHOOL_WIDGET_SCHOOLS,
  ERROR_FETCHING_SCHOOL_WIDGET_DATA,
  ERROR_FETCHING_SCHOOL_WIDGET_SCHOOLS,
  START_FETCHING_SCHOOL_WIDGET_DATA,
  START_FETCHING_SCHOOL_WIDGET_SCHOOLS,
  type doneFetchingSchoolWidgetData,
  type doneFetchingSchoolWidgetSchools,
  type errorFetchingSchoolWidgetData,
  type errorFetchingSchoolWidgetSchools,
  type startFetchingSchoolWidgetData,
  type startFetchingSchoolWidgetSchools,
} from '@zcode-ui/locale-guide'
import { nullReducer, payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { type ExtractActions, handleActions } from 'redux-actions'

export const districtMetaReducer = combineReducers<{ error: string | null; fetching: boolean }>({
  error: handleActions<
    string | null,
    | ExtractActions<typeof errorFetchingSchoolWidgetData>
    | ExtractActions<typeof startFetchingSchoolWidgetData>
  >(
    {
      [ERROR_FETCHING_SCHOOL_WIDGET_DATA]: payloadReducer,
      [START_FETCHING_SCHOOL_WIDGET_DATA]: nullReducer,
    },
    null
  ),
  fetching: handleActions<
    boolean,
    ExtractActions<typeof startFetchingSchoolWidgetData | typeof doneFetchingSchoolWidgetData>
  >(
    {
      [START_FETCHING_SCHOOL_WIDGET_DATA]: () => true,
      [DONE_FETCHING_SCHOOL_WIDGET_DATA]: () => false,
    },
    false
  ),
})

export const schoolsMetaReducer = combineReducers({
  error: handleActions<
    string | null,
    ExtractActions<
      typeof errorFetchingSchoolWidgetSchools | typeof startFetchingSchoolWidgetSchools
    >
  >(
    {
      [ERROR_FETCHING_SCHOOL_WIDGET_SCHOOLS]: payloadReducer,
      [START_FETCHING_SCHOOL_WIDGET_SCHOOLS]: nullReducer,
    },
    null
  ),
  fetching: handleActions<
    boolean,
    ExtractActions<typeof startFetchingSchoolWidgetSchools | typeof doneFetchingSchoolWidgetSchools>
  >(
    {
      [START_FETCHING_SCHOOL_WIDGET_SCHOOLS]: () => true,
      [DONE_FETCHING_SCHOOL_WIDGET_SCHOOLS]: () => false,
    },
    false
  ),
})
